/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as DatenschutzRouteImport } from './routes/datenschutz'
import { Route as DeclinedRouteImport } from './routes/declined'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as RegistrierungRouteImport } from './routes/registrierung'
import { Route as AppointmentAppointmentIdRouteImport } from './routes/appointment.$appointmentId'
import { Route as AssessmentAppointmentIdRouteImport } from './routes/assessment.$appointmentId'
import { Route as BookingInvitationIdRouteImport } from './routes/booking.$invitationId'
import { Route as JoinTokenRouteImport } from './routes/join.$token'
import { Route as TechCheckAppointmentIdRouteImport } from './routes/tech-check.$appointmentId'
import { Route as VideoAppointmentIdRouteImport } from './routes/video.$appointmentId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const DatenschutzRoute = DatenschutzRouteImport.update({
  id: '/datenschutz',
  path: '/datenschutz',
  getParentRoute: () => rootRouteImport,
} as any)
const DeclinedRoute = DeclinedRouteImport.update({
  id: '/declined',
  path: '/declined',
  getParentRoute: () => rootRouteImport,
} as any)
const ImpressumRoute = ImpressumRouteImport.update({
  id: '/impressum',
  path: '/impressum',
  getParentRoute: () => rootRouteImport,
} as any)
const RegistrierungRoute = RegistrierungRouteImport.update({
  id: '/registrierung',
  path: '/registrierung',
  getParentRoute: () => rootRouteImport,
} as any)
const AppointmentAppointmentIdRoute =
  AppointmentAppointmentIdRouteImport.update({
    id: '/appointment/$appointmentId',
    path: '/appointment/$appointmentId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AssessmentAppointmentIdRoute = AssessmentAppointmentIdRouteImport.update({
  id: '/assessment/$appointmentId',
  path: '/assessment/$appointmentId',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingInvitationIdRoute = BookingInvitationIdRouteImport.update({
  id: '/booking/$invitationId',
  path: '/booking/$invitationId',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinTokenRoute = JoinTokenRouteImport.update({
  id: '/join/$token',
  path: '/join/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const TechCheckAppointmentIdRoute = TechCheckAppointmentIdRouteImport.update({
  id: '/tech-check/$appointmentId',
  path: '/tech-check/$appointmentId',
  getParentRoute: () => rootRouteImport,
} as any)
const VideoAppointmentIdRoute = VideoAppointmentIdRouteImport.update({
  id: '/video/$appointmentId',
  path: '/video/$appointmentId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/datenschutz': typeof DatenschutzRoute
  '/declined': typeof DeclinedRoute
  '/impressum': typeof ImpressumRoute
  '/registrierung': typeof RegistrierungRoute
  '/appointment/$appointmentId': typeof AppointmentAppointmentIdRoute
  '/assessment/$appointmentId': typeof AssessmentAppointmentIdRoute
  '/booking/$invitationId': typeof BookingInvitationIdRoute
  '/join/$token': typeof JoinTokenRoute
  '/tech-check/$appointmentId': typeof TechCheckAppointmentIdRoute
  '/video/$appointmentId': typeof VideoAppointmentIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/datenschutz': typeof DatenschutzRoute
  '/declined': typeof DeclinedRoute
  '/impressum': typeof ImpressumRoute
  '/registrierung': typeof RegistrierungRoute
  '/appointment/$appointmentId': typeof AppointmentAppointmentIdRoute
  '/assessment/$appointmentId': typeof AssessmentAppointmentIdRoute
  '/booking/$invitationId': typeof BookingInvitationIdRoute
  '/join/$token': typeof JoinTokenRoute
  '/tech-check/$appointmentId': typeof TechCheckAppointmentIdRoute
  '/video/$appointmentId': typeof VideoAppointmentIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/datenschutz': typeof DatenschutzRoute
  '/declined': typeof DeclinedRoute
  '/impressum': typeof ImpressumRoute
  '/registrierung': typeof RegistrierungRoute
  '/appointment/$appointmentId': typeof AppointmentAppointmentIdRoute
  '/assessment/$appointmentId': typeof AssessmentAppointmentIdRoute
  '/booking/$invitationId': typeof BookingInvitationIdRoute
  '/join/$token': typeof JoinTokenRoute
  '/tech-check/$appointmentId': typeof TechCheckAppointmentIdRoute
  '/video/$appointmentId': typeof VideoAppointmentIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/datenschutz'
    | '/declined'
    | '/impressum'
    | '/registrierung'
    | '/appointment/$appointmentId'
    | '/assessment/$appointmentId'
    | '/booking/$invitationId'
    | '/join/$token'
    | '/tech-check/$appointmentId'
    | '/video/$appointmentId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/datenschutz'
    | '/declined'
    | '/impressum'
    | '/registrierung'
    | '/appointment/$appointmentId'
    | '/assessment/$appointmentId'
    | '/booking/$invitationId'
    | '/join/$token'
    | '/tech-check/$appointmentId'
    | '/video/$appointmentId'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/datenschutz'
    | '/declined'
    | '/impressum'
    | '/registrierung'
    | '/appointment/$appointmentId'
    | '/assessment/$appointmentId'
    | '/booking/$invitationId'
    | '/join/$token'
    | '/tech-check/$appointmentId'
    | '/video/$appointmentId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRoute
  DatenschutzRoute: typeof DatenschutzRoute
  DeclinedRoute: typeof DeclinedRoute
  ImpressumRoute: typeof ImpressumRoute
  RegistrierungRoute: typeof RegistrierungRoute
  AppointmentAppointmentIdRoute: typeof AppointmentAppointmentIdRoute
  AssessmentAppointmentIdRoute: typeof AssessmentAppointmentIdRoute
  BookingInvitationIdRoute: typeof BookingInvitationIdRoute
  JoinTokenRoute: typeof JoinTokenRoute
  TechCheckAppointmentIdRoute: typeof TechCheckAppointmentIdRoute
  VideoAppointmentIdRoute: typeof VideoAppointmentIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/datenschutz': {
      id: '/datenschutz'
      path: '/datenschutz'
      fullPath: '/datenschutz'
      preLoaderRoute: typeof DatenschutzRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/declined': {
      id: '/declined'
      path: '/declined'
      fullPath: '/declined'
      preLoaderRoute: typeof DeclinedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/impressum': {
      id: '/impressum'
      path: '/impressum'
      fullPath: '/impressum'
      preLoaderRoute: typeof ImpressumRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/registrierung': {
      id: '/registrierung'
      path: '/registrierung'
      fullPath: '/registrierung'
      preLoaderRoute: typeof RegistrierungRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/appointment/$appointmentId': {
      id: '/appointment/$appointmentId'
      path: '/appointment/$appointmentId'
      fullPath: '/appointment/$appointmentId'
      preLoaderRoute: typeof AppointmentAppointmentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assessment/$appointmentId': {
      id: '/assessment/$appointmentId'
      path: '/assessment/$appointmentId'
      fullPath: '/assessment/$appointmentId'
      preLoaderRoute: typeof AssessmentAppointmentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking/$invitationId': {
      id: '/booking/$invitationId'
      path: '/booking/$invitationId'
      fullPath: '/booking/$invitationId'
      preLoaderRoute: typeof BookingInvitationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join/$token': {
      id: '/join/$token'
      path: '/join/$token'
      fullPath: '/join/$token'
      preLoaderRoute: typeof JoinTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tech-check/$appointmentId': {
      id: '/tech-check/$appointmentId'
      path: '/tech-check/$appointmentId'
      fullPath: '/tech-check/$appointmentId'
      preLoaderRoute: typeof TechCheckAppointmentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/video/$appointmentId': {
      id: '/video/$appointmentId'
      path: '/video/$appointmentId'
      fullPath: '/video/$appointmentId'
      preLoaderRoute: typeof VideoAppointmentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRoute,
  DatenschutzRoute: DatenschutzRoute,
  DeclinedRoute: DeclinedRoute,
  ImpressumRoute: ImpressumRoute,
  RegistrierungRoute: RegistrierungRoute,
  AppointmentAppointmentIdRoute: AppointmentAppointmentIdRoute,
  AssessmentAppointmentIdRoute: AssessmentAppointmentIdRoute,
  BookingInvitationIdRoute: BookingInvitationIdRoute,
  JoinTokenRoute: JoinTokenRoute,
  TechCheckAppointmentIdRoute: TechCheckAppointmentIdRoute,
  VideoAppointmentIdRoute: VideoAppointmentIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
